import { Button } from "@mui/material";
import type { EditableCallbackParams } from "ag-grid-community";
import { useFormsContext } from "../../context/FormsContext";

type Props = {
	params: EditableCallbackParams;
	setOpenFormAssetAndUsersTable: Function;
};

export const ButtonToShowFormsAssetAndUsers = ({
	params,
	setOpenFormAssetAndUsersTable,
}: Props) => {
	const {
		actions: { setFormId, setFormName },
	} = useFormsContext();

	const handleOpenAssetAndUsersTable = () => {
		setOpenFormAssetAndUsersTable(true);
		setFormId(params.data?.FormId);
		setFormName(params.data?.FormName);
	};

	if (params.data) {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100%",
					padding: 5,
					minWidth: 200,
				}}
			>
				<Button
					style={{ height: "100%", maxHeight: "27px" }}
					fullWidth
					variant={params.data?.AssetCount !== 0 ? "contained" : "outlined"}
					color="primary"
					onClick={() => handleOpenAssetAndUsersTable()}
				>
					{params.data?.AssetCount !== 0
						? params.data?.AssetCount <= 1
							? `${params.data?.AssetCount} ASSET`
							: `${params.data?.AssetCount} ASSETS`
						: "add asset"}
				</Button>
			</div>
		);
	} else return <></>;
};
